import { getMonetaryValueOfMemberBalance } from '../../../../utils/get-monetary-value-of-member-balance';
export const getMonetaryValueLabelForMemberBalance = (i18n, monetaryValueFormat, availableUnits, paymentConversionRate) => {
    if (!paymentConversionRate)
        return undefined;
    return i18n.template(monetaryValueFormat, {
        monetaryValue: getMonetaryValueOfMemberBalance(availableUnits, paymentConversionRate)
    });
};
